const CampaignFilterEnums = {
  ACTIVE: 'active',
  SCHEDULED: 'scheduled',
  REACHED: 'reached',
  ENDING: 'ending',
};

const CampaignFilterStatusEnums = {
  SCHEDULED_PAUSED: 1,
  SCHEDULED: 2,
  TODAY_LIMIT_REACHED: 1,
};

const CampaignFilterValueEnums = {
  ACTIVE: 'Active',
  TODAY_LIMIT_REACHED: "Today's limit reached",
  SCHEDULED_PAUSED: 'Scheduled Paused',
  SCHEDULED: 'Scheduled',
};

const CampaignFilterMetricEnums = {
  TODAY_LIMIT: 'todayLimit',
  PAUSED: 'paused',
  TODAY: 'today',
  NEXT_7_DAYS: 'next7Days',
  NEXT_3_DAYS: 'next3Days',
};

export {
  CampaignFilterEnums,
  CampaignFilterStatusEnums,
  CampaignFilterValueEnums,
  CampaignFilterMetricEnums,
};
